import { useState, useCallback } from "react"
import type { AuditFormData, UseAuditFormReturn } from "../types"
import { DEFAULT_FORM_DATA, VALIDATION_RULES } from "../constants"

export const useAuditForm = (): UseAuditFormReturn => {
  const [formData, setFormData] = useState<AuditFormData>(DEFAULT_FORM_DATA)

  const handleFieldChange = useCallback((field: keyof AuditFormData, value: any) => {
    setFormData((prev) => ({ ...prev, [field]: value }))
  }, [])

  const resetForm = useCallback(() => {
    setFormData(DEFAULT_FORM_DATA)
  }, [])

  const validateStep = useCallback(
    (step: number): boolean => {
      switch (step) {
        case 0:
          return !!formData.type
        case 1:
          if (formData.type === "automatic") {
            return (
              !!formData.automaticType &&
              !!formData.percentage &&
              formData.percentage >= VALIDATION_RULES.MIN_PERCENTAGE &&
              formData.percentage <= VALIDATION_RULES.MAX_PERCENTAGE
            )
          }
          if (formData.type === "specific") {
            return !!(formData.specificProducts && formData.specificProducts.length > 0)
          }
          return true
        default:
          return true
      }
    },
    [formData]
  )

  return {
    formData,
    handleFieldChange,
    resetForm,
    validateStep
  }
}
